let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aKgoC")).then(() => parcelRequire('wwOu8'));